module.exports = __webpack_public_path__ + "img/12225_25.e853d88f.png";